
class MetaTagsManipulator {

    static setDefaultTitle() {
        document.title = "GO-auto";
    }

    static setTitle(title){
        document.title = title + " - GO-auto ";
    }

    static setDescription(description){
        if(description != null) {
            // document.description nie istnieje — wcześniejsza wersja zapisywała
            // opis w nigdy nieczytane pole, przez co <meta name="description">
            // zostawał z domyślną treścią z index.html.
            let tag = document.querySelector('meta[name="description"]');

            if (!tag) {
                tag = document.createElement('meta');
                tag.setAttribute('name', 'description');
                document.head.appendChild(tag);
            }

            tag.setAttribute('content', description);
        }
    }

    static getTitle() {
        return document.title;
    }

    static getDescription() {
        const tag = document.querySelector('meta[name="description"]');

        return tag ? tag.getAttribute('content') : null;
    }

}

export default MetaTagsManipulator;